export const color = {
    "Primary": "#04686a",
    "Black": "#000",
    "White": "#FFF",
    "Gray":"#EDEDED"
}